export default __webpack_public_path__ + "static/media/Aleena.72f4a77d.jpeg";